import { redirect } from "@tanstack/react-router";
import type { ParsedLocation } from "@tanstack/react-router";
import type { RouterContext } from "@/routes/__root.tsx";
import type { Role } from "@/types/api/types.ts";
import { ROLE_SUPER_ADMIN } from "@/constants";

type BeforeLoadArgs = {
  context: RouterContext;
  location: ParsedLocation;
};

export const requireRole = (requiredRoles: Role[]) => {
  return ({ context, location }: BeforeLoadArgs) => {
    const userRoles = context.session?.user?.roles;

    const isSuperAdmin = userRoles?.includes(ROLE_SUPER_ADMIN);

    const hasRequiredRole = userRoles?.some((role) =>
      requiredRoles.includes(role)
    );

    if (!isSuperAdmin && !hasRequiredRole) {
      console.warn("❌ REDIRECTING FROM requireRole");
      throw redirect({
        to: "/unauthorized",
        search: {
          redirect: location.href,
        },
      });
    }
  };
};
